import React from 'react'
import { Link, IndexLink, matchPath } from 'react-static'

function NavLink({...props}) {
  const activeClassName = "site-nav__item--active";
  let matchParams = {
    path: props.to,
    exact: false,
    strict: true
  }
  let isActive = false;

  if (typeof window !== 'undefined') {
    if (props.to === '/') {
      if (window.location.pathname === '/') {
        isActive = activeClassName;
      }
    } else {
      isActive = matchPath(window.location.pathname, matchParams) ? activeClassName : '';
    }
  }

  return(
    <li className={`site-nav__item ${isActive}`}>
      {props.children}
    </li>
  );
}

export default NavLink;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Nav-Link.js